import { FormControl, FormErrorMessage, FormHelperText, FormLabel, Input } from "@chakra-ui/react";
import type { UseFormRegisterReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ContributingEntityRole } from "../../../../../autogen/bff-api";
import { groupRoleLabel } from "./contributingEntityRoles";

export const declaresGroupRole = (role: ContributingEntityRole): boolean =>
  role !== ContributingEntityRole.CapacityProvider;

interface Props {
  role: ContributingEntityRole;
  registration: UseFormRegisterReturn;
  error?: string;
}

export const GroupRoleField = ({ role, registration, error }: Props) => {
  const { t } = useTranslation();
  const isConsortium = role === ContributingEntityRole.ConsortiumMember;

  return (
    <FormControl isRequired isInvalid={error !== undefined}>
      <FormLabel fontSize="sm">{groupRoleLabel(role, t)}</FormLabel>
      <Input {...registration} />
      <FormErrorMessage>{error}</FormErrorMessage>
      <FormHelperText fontSize="xs">
        {isConsortium
          ? t("Listed next to the company in the self-declaration's Part II A.")
          : t("Listed next to the company in the self-declaration's Part II D.")}
      </FormHelperText>
    </FormControl>
  );
};
